// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ReleaseOut = zod.object({
  "deployed_at": zod.union([zod.string(),zod.null()]),
  "version": zod.string()
});

export type ReleaseOut = zod.input<typeof ReleaseOut>;
export type ReleaseOutOutput = zod.output<typeof ReleaseOut>;
